<script lang="ts" setup>
const props = defineProps({
  schema: {
    default: () => [],
    type: Array as PropType<AnimationSchemaElement[]>,
  },
})

const containerRef = ref<any>()
const elementRefs = ref<Record<string, any>>({})
const beams = ref<{ from: any, to: any }[]>([])

onMounted(() => {
  initializeElementRefs()
})

function initializeElementRefs() {
  const links: [string, string][] = []

  for (const [index, item] of Object.entries(props.schema)) {
    if (item.links?.length) {
      for (const link of item.links) {
        const from = index
        const to = props.schema.findIndex(item => item.id === link)?.toString()

        links.push([from, to])
      }
    }
  }

  for (const [from, to] of links) {
    beams.value.push({
      from: elementRefs.value[from],
      to: elementRefs.value[to],
    })
  }
}
</script>

<template>
  <AnimationContainer
    ref="containerRef"
    :has-borders="false"
    width="w-full mx-auto"
  >
    <AnimationItem
      v-for="(item, itemIndex) in schema"
      :key="itemIndex"
      :ref="(elementRef) => (elementRefs[itemIndex] = elementRef)"
      :badge-position="item['badge-position']"
      :icon="getIcon(item.icon)"
      :title="item.label"
    />

    <ClientOnly v-if="containerRef && beams.length">
      <AnimationBeam
        v-for="(beam, index) in beams"
        :key="index"
        :container-ref="containerRef.$el"
        :from-ref="beam.from.$el"
        :to-ref="beam.to.$el"
      />
    </ClientOnly>
  </AnimationContainer>
</template>
